import { HexColor } from '@wix/thunderbolt-becky-root'

/** Internal Converters */
const hexColorConverter = (prop: HexColor): string => {
	return `${prop.value}`
}

/** External Mapper */
export const colorConverterMap = {
	HexColor: hexColorConverter,
}
